/* ErrorMapTranslation.js */

"use strict";

const ErrorMapTranslation = {
    Common: {
        NotAuthorized: "User is not authorized for this action."
    },
    User: {
        default_entry: "Invalid entry.",
        userName: "Username is a required field",
        first: "First name is a required field",
        last: "Last name is a required field",
        email: "Invalid email address",
        authorizedOrganizationIds: "At least 1 organization must be selected for 'Some' visibility",
        password: "Password is required",
        actionGroupId: "Role is required"
    },
    Organization: {
        name: "Organization Name is required",
        default_entry: "Invalid form value",
        ldap: {
            adminPassword: "Admin User Password is required",
            adminDn: "Admin Distinguished Name is required",
            userDomain: "LDAP Domain is required",
            host: "Host is required",
            port: "Port is required",
            baseDn: "Base Distinguished Name is required",
            userNameAttr: "Username Attribute is required",
            ssl: false,
            skipIdentityCheck: false,
            tlsCert: undefined,
            mapping: {
                email: "",
                first: "",
                last: "",
                actionGroup: "",
                actionAuthMapping: {
                    readOnlyAdmin: "",
                    writeAdmin: "",
                    systemAdmin: "",
                    systemDeveloper: ""
                },
                orgVisibility: ""
            },
            defaultActionGroupId: "",
            defaultOrgVisibility: "ALL"
        },
        radius: {
            userDomain: "RADIUS Domain is required",
            host: "Host is required",
            port: "Port is required",
            secret: "RADIUS Server Secret is required",
            requestTimeout: "Request Timeout is required",
            requestRetries: "Request Retries is required",
            secondaryHost: "Secondary Host is required",
            accountingHost: "Accounting Host is required",
            secondaryAccountingHost: "Secondary Accounting Host is required"
        }
    }
};

ErrorMapTranslation.generateDefaultErrorMessage = function(errorPath) {
    const pathArray = errorPath.split(".");
    let fieldName = pathArray[pathArray.length - 1];
    return fieldName + " is required";
};
// Test LDAP and Test Radius server calls use ldapConfig and radiusConfig
ErrorMapTranslation.Organization.ldapConfig = ErrorMapTranslation.Organization.ldap;
ErrorMapTranslation.Organization.radiusConfig = ErrorMapTranslation.Organization.radius;

module.exports = ErrorMapTranslation;
